import React, { Component, Fragment, useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Input,
  Button,
  Alert,
  Table,
  CustomInput,
} from "reactstrap";
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput";
import LaddaButton, { SLIDE_LEFT } from "react-ladda";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";

import { getBaseAndPriceCurrencies, ProcessingMode } from "../../../utils/Order/Order";
import { accountProps, customFetchAssetInfo, customFetchAccountInfo } from "../Order/Form/commons";
import OrderInlineDetail from "../../Order/InlineDetail";
import ExecutionsTable from "../../ExecutionsTable/ExecutionsTable";
import { Field, Combobox, Switch, Symbol } from "../Order/Field/Field";
import { TradingRoutes, fetchCParties, CounterpartySuggest } from "../Trading/FormFields";
import { OrderStatus, getOrderStats } from "../../../utils";
import { debounce, showToast } from "../../../utils/Helper";
import TradingRoutesLogs from "./Controls";
import CircularProgress from "../../CircularProgress/CircularProgress";
import { CouponPayments } from "../../Asset/Tabs/Contracts/Contracts";
import Autosuggest from "../../Autosuggest/Autosuggest";
import * as _state from "./_state";

import style from "./Execution.module.scss";

class Execution extends Component {
  constructor(props) {
    super(props);
    _state.initialize.call(this, {
      ...props.order,
      manualFX: false,
      maxDecimals: 4,
      parValue: 1,
      total: undefined,
      calculatingTotal: false,
      isWritten: false,
      calculatingLegs: false,
      decimalAmount: undefined,
      newSymbol: false,
    });
  }

  calculateTotal() {
    const { order, services } = this.props;
    const { fetchGetCalculator, fetchCurrencyFXbyDate } = services;

    this.setState((prevState) => ({ ...prevState, calculatingTotal: true }));
    if (order.AssetClassForm != "Forex") {
      const body = {
        assetId: order.AssetId,
        isSecurity: true,
        date: this.state.execution.ExecutionValueDate,
        price: parseFloat(this.state.execution.ExecutionPrice),
        quantity: this.state.execution.ExecutionQuantity,
        priceisclean: false,
        priceisdirty: false,
      };
      fetchGetCalculator(body).then((res) => {
        this.setState((prevState) => ({
          ...prevState,
          total: res.calculator.total,
          calculatingTotal: false,
          execution: { ...prevState.execution, ExecutionTotal: res.calculator.total },
        }));
      });
    } else {
      const body = {
        baseCurrency: order.OrderCurrencyId,
        targetCurrency: order.OrderSettlementCurrencyId,
        date: this.state.execution.ExecutionValueDate,
      };

      fetchCurrencyFXbyDate(body).then((res) => {
        let total;
        if (res.FX.divides)
          total =
            parseFloat(this.state.execution.ExecutionQuantity) /
            parseFloat(this.state.execution.ExecutionPrice);
        else
          total =
            parseFloat(this.state.execution.ExecutionQuantity) *
            parseFloat(this.state.execution.ExecutionPrice);

        total = isNaN(total) ? 0 : total;
        this.setState((prevState) => ({
          ...prevState,
          total: total,
          calculatingTotal: false,
          execution: { ...prevState.execution, ExecutionTotal: total },
        }));
      });
    }
  }

  getEntities() {
    const { entities, saveEntities } = this.props;

    const isStoredData =
      entities && entities.counterparties && Object.entries(entities.counterparties).length > 0;

    //Si los datos ya se encuentran guardados, no llamamos a la API.
    if (isStoredData || entities.isLoading) {
      return;
    }

    //Se llama a la API y se almacena en redux.
    saveEntities && saveEntities();
  }

  componentDidMount() {
    const trader_name_input =
      window.___APP_CONFIG___ && window.___APP_CONFIG___.TRADER_NAME_INPUT
        ? window.___APP_CONFIG___.TRADER_NAME_INPUT
        : false;
    this.setState((prevState) => ({ ...prevState, showTraderName: trader_name_input }));
    this.getTradingRoutes();
    this.getTradesAllowedTimeSpan();
    if (trader_name_input) {
      this.getAuthorizedTraders();
    }
    this.getEntities();
    if (this.props.order) {
      this.getSettlementCurrencies(true, true);
      if (this.props.order.AssetClassForm === "Repo") {
        const newContractdata = {
          ContractType: "Repo",
          term: this.props.order.OrderTerm,
          margin: 0,
          RefAssetid: this.props.order.AssetId,
          price: 0,
          rate: this.props.order.OrderType === "Limit" ? +this.props.order.OrderPrice : 0,
          limit: this.props.order.OrderType === "Limit" ? +this.props.order.OrderPrice : 0,
          appraisal: 100,
          marketValue: 0,
          currency: this.props.order.OrderCurrencySymbol,
          open: false,
          opening: 0,
          closing: 0,
          couponPayments: [],
          CollateralAssetid: 0,
          CollateralAssetTicker: "",
          CollateralQuantity: 0,
          paymenttoborrower: 0,
        };

        this.setState((prevState) => {
          return {
            ...prevState,
            execution: {
              ...prevState.execution,
              contractdata: newContractdata,
            },
          };
        });

        if (this.props.order.OrderSide === "Sell") {
          this.props.services
            .fetchGetAssetInformation({ assetId: this.props.order.CurrentAccount.Collateral[0].AssetId })
            .then((response) => {
              this.setState((prevState) => ({
                ...prevState,
                decimalAmount: response.info.SubAssetClassDecimalPlaces,
              }));
            })
            .catch((err) => {
              console.error(err);
              showToast("Error fetching the Asset Class Information", true);
            });

          this.props.services
            .fetchGetAssetQuote({
              assetquote_in: {
                assetid: this.props.order.CurrentAccount.Collateral[0].AssetId,
                Date: this.state.execution.ExecutionDate,
                AssetQuotePrice: true,
              },
            })
            .then(({ response }) => {
              if (this.props.order.CurrentAccount.Collateral) {
                this.setState(
                  (prevState) => ({
                    ...prevState,
                    execution: {
                      ...prevState.execution,
                      contractdata: {
                        ...prevState.execution.contractdata,
                        price: response.assetquote_out.AssetQuotePrice,
                        CollateralAssetid: this.props.order.CurrentAccount.Collateral[0].AssetId,
                        CollateralAssetTicker: this.props.order.CurrentAccount.Collateral[0].AssetTicker,
                        CollateralQuantity: this.props.order.CurrentAccount.Collateral[0].CollateralQuantity,
                      },
                    },
                  }),
                  () => this.handleGetLegs()
                );
              } else {
                showToast("Error fetching order data, no collateral information found", true);
              }
            })
            .catch((err) => {
              console.error(err);
              showToast("Error fetching collateral asset price", true);
            });
        }

        //Looks for who is the default contract side that takes the repo payments
        if (this.props.services.getRepoDefaultPaymentsCorrespondent) {
          const { execution } = this.state;
          this.getRepoDefaultPaymentToBorrower(execution.TradingRouteId);
        }
      } else {
        this.props.services
          .fetchGetAssetInformation({ assetId: this.props.order.AssetId })
          .then((response) => {
            const isFXOrder = this.props.order.AssetClassForm == "Forex";
            this.setState((prevState) => ({
              ...prevState,
              decimalAmount: isFXOrder ? 2 : response.info.SubAssetClassDecimalPlaces,
            }));
          })
          .catch((err) => {
            console.error(err);
            showToast("Error fetching the Asset Class Information", true);
          });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { order: prevOrder } = prevProps;
    const { order } = this.props;
    const { execution: prevExecution } = prevState;
    const { execution, manualFX } = this.state;
    if (
      order.OrderCurrencyId != prevOrder.OrderCurrencyId ||
      order.OrderSettlementCurrencyId != prevOrder.OrderSettlementCurrencyId ||
      prevOrder.AssetId != order.AssetId ||
      prevExecution.ExecutionDate != execution.ExecutionDate ||
      prevExecution.ExecutionValueDate != execution.ExecutionValueDate
    ) {
      const updateValueDate =
        prevOrder.AssetId != order.AssetId || prevExecution.ExecutionDate != execution.ExecutionDate;

      const updateFX = !manualFX;

      this.getSettlementCurrencies(updateValueDate, updateFX);
    }

    if (prevExecution.ExecutionTotal != execution.ExecutionTotal) {
      this.handleGetFees();
    }

    if (prevExecution.ExecutionDate != execution.ExecutionDate) {
      this.getTradesAllowedTimeSpan();
    }

    if (prevExecution.TradingRouteId !== execution.TradingRouteId) {
      this.handleGetFees();
      this.getRepoDefaultPaymentToBorrower(execution.TradingRouteId);
    }
  }

  onChange = (values) => {
    _state.changeValues.call(this, values);
  };

  updateSettlementDate = () => {
    if (this.props.order.AssetClassForm == "Repo" && this.state.execution.contractdata) {
      this.handleGetLegs();
    }
  };

  delayedUpdateFilterValue = (name, value) => {
    this.setState((prevState) => ({
      delayedFilter: {
        ...prevState.delayedFilter,
        [name]: value,
      },
    }));

    this.handleFilterDebounced();
  };

  getRepoDefaultPaymentToBorrower = (id) => {
    if (this.props.services.getRepoDefaultPaymentsCorrespondent) {
      this.props.services.getRepoDefaultPaymentsCorrespondent(id).then(({ response }) => {
        const data = response ? response.execution : null;
        const paymentToBorrower = data && data.contractdata ? data.contractdata.paymenttoborrower : 0;
        return this.setState((prevState) => {
          return {
            ...prevState,
            execution: {
              ...prevState.execution,
              contractdata: { ...prevState.execution.contractdata, paymenttoborrower: paymentToBorrower },
            },
          };
        });
      });
    }
  };

  confirm = () => {
    // validate
    const noErrors = _state.validate.call(this, this.props.order);

    if (noErrors) {
      this.setState((prevState) => ({ ...prevState, loading: true }));

      const { orderId, order, relatedOrder, services } = this.props;
      const { fetchAddExecution } = services;
      const { settlementCurrencies, total } = this.state;

      const settleCurrencyInfo = settlementCurrencies.find(
        (c) => c.currencyInfo.currencyISO == order.OrderSettlementCurrencySymbol
      );

      const execution = {
        ...this.state.execution,
        ExecutionFXMultiplies: settleCurrencyInfo ? settleCurrencyInfo.multiplies : true,
        ExecutionTotal: total,
        contractdata: {
          ...this.state.execution.contractdata,
          contractCounterParty: this.state.execution.CounterPartyId,
        },
      };

      fetchAddExecution({
        execution,
        orderId,
      })
        .then((res) => res.response)
        .then((res) => {
          if (res.result.Code !== 200) {
            alert(res.result.Description);
            this.setState((prevState) => ({ ...prevState, loading: false }));
          } else {
            const qtyPending = _state.calculateAvailableQty(order) - execution.ExecutionQuantity;

            if (qtyPending == 0 && relatedOrder != null) {
              _state.clear.call(this);
              this.props.onToggle(true, { order: relatedOrder });
            } else {
              _state.clear.call(this, qtyPending > 0 ? { ExecutionQuantity: qtyPending } : {});
            }
          }
        });
    }
  };

  getTradingRoutes = () => {
    const { order, services } = this.props;
    const { OrderId } = order;
    const { fetchTradingRoutes } = services;
    const { execution } = this.state;

    fetchTradingRoutes({ processId: OrderId, quantity: this.state.execution.ExecutionQuantity })
      .then((res) => ({
        routes: res.response.sorroutes,
        logs: res.response.keyvalues,
      }))
      .then(({ routes, logs }) => {
        //remove duplicates
        let uniqueRoutes = [];

        let preferredRouteId = -1;
        let betterPreference = 9999;

        routes.forEach((r) => {
          if (r.name != "") {
            if (uniqueRoutes.find((e) => e.id == r.id) == undefined) {
              uniqueRoutes.push(r);
              if (r.preference < betterPreference) {
                preferredRouteId = r.id;
                betterPreference = r.preference;
              }
            }
          }
        });

        if (uniqueRoutes.find((e) => e.id == execution.TradingRouteId) == undefined) {
          this.onChange({ TradingRouteId: preferredRouteId });
        }

        _state.setTradeRoutes.call(
          this,
          uniqueRoutes.map((r) => ({
            id: r.id,
            description: r.name,
          })),
          logs
        );
      });
  };

  getAuthorizedTraders = () => {
    if (this.props.services.getAuthorizedTraders) {
      this.props.services.getAuthorizedTraders().then((r) => {
        r.response &&
          this.setState((prevState) => ({
            ...prevState,
            authUsers: r.response.authUsers,
            execution: { ...prevState.execution, ExecutionTrader: "" },
          }));
      });
    }
  };

  getTradesAllowedTimeSpan = () => {
    const { services } = this.props;
    const { execution } = this.state;

    services
      .getTradesTimeSpan({ date: execution.ExecutionDate })
      .then(({ response }) => {
        this.setState((state) => ({
          ...state,
          minTradeDate: response.startingTime,
          maxTradeDate: response.endingTime,
          restricted: response.restricted,
        }));
      })
      .catch((err) => {
        console.error(err);
      });
  };

  getSettlementCurrencies = (updateValueDate, updateFX) => {
    const { order, services } = this.props;
    const { fetchOrderAssetInfo } = services;
    const { execution } = this.state;

    const data = {
      tradeDate: execution.ExecutionDate,
      valueDate: execution.ExecutionValueDate,
      useValueDate: !updateValueDate,
      orderForm: order.AssetClassForm,
      assetId: order.AssetId,
      assetTicker: order.AssetTicker,
      tradeCurrencyId: order.OrderCurrencyId,
      settleCurrencyId: order.OrderSettlementCurrencyId,
    };

    const isFXOrder = order.AssetClassForm == "Forex";

    fetchOrderAssetInfo(data).then((res) => {
      const { settlementCurrency: settlementCurrencies, items } = res.response.assetorderdata;
      let fx;
      let valueDate;

      if (settlementCurrencies) {
        fx = isFXOrder ? execution.ExecutionPrice : execution.ExecutionFX;
        if (updateFX) {
          const settleCurrency = settlementCurrencies.find(
            (c) => c.currencyInfo.currencyId == order.OrderSettlementCurrencyId
          );
          fx ? parseFloat(settleCurrency.fx) : null;
        }
      }

      if (updateValueDate && items.find((i) => i.key == "SettlementDayDate")) {
        valueDate = items.find((i) => i.key == "SettlementDayDate").value;
      }

      let maxDecimals = 4;
      if (items.find((i) => i.key == "MaxDecimals")) {
        maxDecimals = parseInt(items.find((i) => i.key == "MaxDecimals").value, 10);
      }

      let parValue = 1.0;
      if (items.find((i) => i.key == "ParValue")) {
        parValue = parseFloat(items.find((i) => i.key == "ParValue").value);
      }

      this.setState((state) => {
        const newExecution = {
          ...state.execution,
          ExecutionValueDate: valueDate || state.execution.ExecutionValueDate,
          ExecutionFX: fx || state.execution.ExecutionFX,
        };

        if (!this.state.isWritten) {
          newExecution.ExecutionPrice = fx || state.execution.ExecutionPrice;
        }
        // this.setState({ isWritten: true }); ¿?
        return {
          ...state,
          isWritten: true,
          settlementCurrencies: settlementCurrencies ? settlementCurrencies : state.settlementCurrencies,
          maxDecimals,
          parValue,
          execution: newExecution,
        };
      });
    });
  };

  delete = (execution, callback = () => {}) => {
    const { orderId, order, services } = this.props;
    const { fetchRemoveExecution } = services;
    const executionId = execution.ExecutionId;
    const childId = execution.childId;

    fetchRemoveExecution({ executionId, childId, orderId }).then((response) => {
      if (response.response.result.Code == 200) {
        const qtyPending = order.stats.pending - +execution.ExecutionQuantity;
        _state.clear.call(this, qtyPending > 0 ? { ExecutionQuantity: qtyPending } : {});
      } else {
        alert(response.response.result.Description);

        const qtyPending = order.stats.pending;
        _state.clear.call(this, qtyPending > 0 ? { ExecutionQuantity: qtyPending } : {});
      }
      callback();
    });
  };

  onToggle = () => {
    _state.clear.call(this);
    this.props.onToggle();
  };

  renderSuggestion = (suggestion) => {
    return (
      <div className={style.suggestionItem}>
        {suggestion.Ticker}
        {" - "}
        <span>{suggestion.Description}</span>
      </div>
    );
  };

  getSuggestionValue = (suggestion) => suggestion.Ticker;

  onSuggestionsFetchRequested = ({ value }) => {
    return this.props.services
      .fetchSearchSymbol({
        type: "Forex",
        text: value,
      })
      .then((response) => response.response.symbols);
  };

  handleGetLegs = () => {
    if (this.props.services.fetchGetOpeningAndClosingLegs) {
      this.setState((prevState) => ({ ...prevState, calculatingLegs: true }));
      this.props.services
        .fetchGetOpeningAndClosingLegs({ execution: this.state.execution })
        .then(({ response }) => {
          this.onChange({ ExecutionPrice: response.openingleg });
          this.setState((prevState) => ({
            ...prevState,
            execution: {
              ...prevState.execution,
              contractdata: {
                ...prevState.execution.contractdata,
                closing: response.closingleg,
                opening: response.openingleg,
                marketValue: response.marketvalue,
                couponPayments: response.cashflow_outs.map((payment) => ({
                  ContractPaymentDate: payment.date,
                  ContractPaymentName: payment.name,
                  ContractPaymentAmmount: payment.payment,
                  ContractPaymentAdjustedAmmount: payment.adjusted,
                })),
              },
            },
          }));
        })
        .catch((err) => {
          console.error(err);
          showToast("Error fetching opening and closing legs", true);
        })
        .finally(() => {
          this.setState((prevState) => ({ ...prevState, calculatingLegs: false }));
          this.handleGetFees();
        });
    }
  };

  handleGetCollateralPrice = () => {
    this.props.services
      .fetchGetAssetInformation({ assetId: this.state.execution.contractdata.CollateralAssetid })
      .then((response) => {
        this.setState((prevState) => ({
          ...prevState,
          decimalAmount: response.info.SubAssetClassDecimalPlaces,
        }));
      });
    this.props.services
      .fetchGetAssetQuote({
        assetquote_in: {
          assetid: this.state.execution.contractdata.CollateralAssetid,
          Date: this.state.execution.ExecutionDate,
          AssetQuotePrice: true,
        },
      })
      .then(({ response }) => {
        this.setState(
          (prevState) => ({
            ...prevState,
            execution: {
              ...prevState.execution,
              contractdata: {
                ...prevState.execution.contractdata,
                price: response.assetquote_out.AssetQuotePrice,
              },
            },
          }),
          () => this.handleGetLegs()
        );
      })
      .catch((err) => {
        console.error(err);
        showToast("Error fetching collateral asset price", true);
      });

    this.setState((prevState) => ({ ...prevState, calculatingPrice: true }));
    this.props.services
      .fetchGetOpeningAndClosingLegs({ execution: this.state.execution })
      .then(({ response }) => {
        this.setState((prevState) => ({
          ...prevState,
          execution: {
            ...prevState.execution,
            contractdata: {
              ...prevState.execution.contractdata,
              closing: response.closing,
              opening: response.openingleg,
              marketValue: response.marketvalue,
              couponPayments: response.cashflow_outs.map((payment) => ({
                ContractPaymentDate: payment.date,
                ContractPaymentName: payment.name,
                ContractPaymentAmmount: payment.payment,
                ContractPaymentAdjustedAmmount: payment.adjusted,
              })),
            },
          },
        }));
      })
      .catch((err) => {
        console.error(err);
        showToast("Error fetching opening and closing legs", true);
      })
      .finally(() => {
        this.setState((prevState) => ({ ...prevState, calculatingPrice: false }));
      });
  };

  handleChangeAppraisal = (event) => {
    const value = event.value;
    this.setState(
      (prevState) => ({
        ...prevState,
        execution: {
          ...prevState.execution,
          contractdata: {
            ...prevState.execution.contractdata,
            appraisal: value,
            margin: 100 - +value,
          },
        },
      }),
      () => this.handleGetLegs()
    );
  };

  handleChangeHaircut = (event) => {
    const value = event.value;
    this.setState(
      (prevState) => ({
        ...prevState,
        execution: {
          ...prevState.execution,
          contractdata: {
            ...prevState.execution.contractdata,
            margin: value,
            appraisal: 100 - +value,
          },
        },
      }),
      () => this.handleGetLegs()
    );
  };

  handleChangeContractData = (name, value) => {
    return this.setState(
      (prevState) => {
        return {
          ...prevState,
          execution: {
            ...prevState.execution,
            contractdata: {
              ...prevState.execution.contractdata,
              [name]: value,
            },
          },
        };
      },
      () => this.handleGetLegs()
    );
  };

  handleChangeClosingLeg = (name, value) => {
    this.setState((prevState) => ({
      ...prevState,
      execution: {
        ...prevState.execution,
        contractdata: {
          ...prevState.execution.contractdata,
          [name]: value,
        },
      },
    }));
  };

  onChangeCollateral = (v) => {
    this.setState(
      (prevState) => ({
        ...prevState,
        execution: {
          ...prevState.execution,
          contractdata: {
            ...prevState.execution.contractdata,
            CollateralAssetid: v.AssetId,
            CollateralAssetTicker: v.AssetTicker,
          },
        },
      }),
      () => this.handleGetCollateralPrice()
    );
  };

  handleGetFees = () => {
    const execution = {
      ...this.state.execution,
      SettlementCurrencyId: this.props.order.OrderSettlementCurrencyId,
    };
    this.props.services
      .getExecutionFees({ execution })
      .then(({ response }) => {
        this.setState((prevState) => ({
          ...prevState,
          execution: {
            ...prevState.execution,
            Fees: response.execution.Fees,
          },
        }));
      })
      .catch((err) => {
        console.error(err);
        showToast("Error fetching fees");
      });
  };

  handleSelectedTrader = (name) => {
    this.setState((prevState) => ({
      ...prevState,
      execution: { ...prevState.execution, ExecutionTrader: name },
    }));
  };

  onChangeTradeDate(e) {
    const { order, applySetDefaultExecTime, tradeDateStartTime, tradeDateEndTime } = this.props;
    const isBuy = order.OrderSide == "Buy";
    const dateTime = e.target.value;
    const inputRef = e.target;

    const tradeDateStartTimeHasValue = this.isValidTimeString(tradeDateStartTime);
    const tradeDateEndTimeHasValue = this.isValidTimeString(tradeDateEndTime);

    if (!applySetDefaultExecTime) {
      this.onChange({ ExecutionDate: dateTime });
      return;
    }

    const newTradeDate = new Date(dateTime);
    const previousExecutionDate = new Date(this.state.execution.ExecutionDate);
    const initialDate = new Date(this.state.initialDate);

    if (this.shouldApplyDefaultTime(newTradeDate, previousExecutionDate, initialDate)) {
      const time = this.getTime(
        isBuy,
        tradeDateStartTimeHasValue,
        tradeDateEndTimeHasValue,
        tradeDateStartTime,
        tradeDateEndTime
      );

      newTradeDate.setHours(time.hours, time.minutes, 0, 0);
      inputRef.blur();
    }

    this.onChange({ ExecutionDate: newTradeDate.toDatetimeLocal() });
  }

  getTime(isBuy, tradeDateStartTimeHasValue, tradeDateEndTimeHasValue, tradeDateStartTime, tradeDateEndTime) {
    //Default values
    let hours = isBuy ? 10 : 15;
    let minutes = 0;

    //Si la fecha es correcta, nos quedamos con el valor dependiendo si es compra o venta.
    const timeString = isBuy
      ? tradeDateStartTimeHasValue
        ? tradeDateStartTime
        : null
      : tradeDateEndTimeHasValue
      ? tradeDateEndTime
      : null;

    //La hora esta en formato {hh:mm}
    if (timeString) {
      hours = Number(timeString.slice(0, 2));
      minutes = Number(timeString.slice(2));
    }

    return { hours, minutes };
  }

  isValidTimeString(timeStr) {
    return timeStr && timeStr.length >= 4 && timeStr !== "0000";
  }

  shouldApplyDefaultTime(newTradeDate, previousExecutionDate, initialDate) {
    const hasChangedTime =
      newTradeDate.getHours() !== previousExecutionDate.getHours() ||
      newTradeDate.getMinutes() !== previousExecutionDate.getMinutes();

    const hasChangedInitialTime =
      newTradeDate.getHours() !== initialDate.getHours() ||
      newTradeDate.getMinutes() !== initialDate.getMinutes();

    return newTradeDate < initialDate && !hasChangedTime && !hasChangedInitialTime;
  }

  render() {
    const { order, entities, applyMarkupTrader } = this.props;

    const { fetchSearchSymbol, fetchSearchRepoSymbol, fetchYahooOptions, fetchOrderAssetInfo } =
      this.props.services;

    if (order == null) {
      return null;
    }

    if (!order.stats) {
      order.stats = getOrderStats(order);
    }

    const {
      OrderLowTouchEnabled: enabledLT,
      OrderQuantityIsCash: quantityIsCash,
      OrderCurrencySymbol,
      OrderSettlementCurrencySymbol,
    } = order;

    const {
      execution,
      errors,
      loading,
      tradeRoutes,
      tradeRoutesLogs,
      availableQty,
      settlementCurrencies,
      maxDecimals,
      parValue,
      manualFX,
    } = this.state;

    const { baseCurrency, priceCurrency } = getBaseAndPriceCurrencies(
      settlementCurrencies,
      OrderCurrencySymbol,
      OrderSettlementCurrencySymbol
    );

    let executions = [];

    let executedQuantity = 0;

    if (order.Childs) {
      order.Childs.forEach((child) => {
        executedQuantity += quantityIsCash
          ? parseFloat(child.ChildOrderQuantity) * parseFloat(child.ChildOrderPrice) * parValue
          : parseFloat(child.ChildOrderQuantity);

        if (child.Executions) {
          child.Executions.forEach((exec) => {
            executions.push({
              ...exec,
              childId: child.ChildOrderId,
              disabled:
                child.ChildProcessingMode != "" && child.ChildProcessingMode != ProcessingMode.HighTouch,
            });
          });
        }
      });
    }

    const pendingQuantity = order.OrderQuantity - executedQuantity;

    // The OrderStatus is undefined if the order is a new order created by the trader.
    const isManualAndActive =
      (!order.OrderIsAutomatic &&
        order.OrderIsActive &&
        ![OrderStatus.EXPIRED, OrderStatus.CANCELED, OrderStatus.REJECTED].includes(order.OrderStatus)) ||
      order.OrderStatus == undefined;

    return (
      <div>
        <Modal isOpen={this.props.open} toggle={this.onToggle} className={style.modal}>
          <ModalHeader toggle={this.onToggle}>
            {isManualAndActive ? "New execution" : "Executions"}
            <OrderInlineDetail order={order} />
          </ModalHeader>
          <ModalBody style={{ padding: "10px 8px" }}>
            <Container>
              {isManualAndActive && (
                <Fragment>
                  {enabledLT && (
                    <Alert
                      color="warning"
                      className="p-1 pl-2 pr-2 mb-2"
                    >{`Available HighTouch quantity: ${availableQty}`}</Alert>
                  )}
                  {quantityIsCash && (
                    <React.Fragment>
                      <Row>
                        <Col lg={12}>
                          <div className={style.cashInfo}>
                            <Alert color="info" className="p-1 pl-2 pr-2 mb-2">
                              {"Order quantity is cash"}
                            </Alert>
                            <div className={style.content}>
                              <div>
                                <span>Pending cash:</span>
                                <FormattedNumber value={pendingQuantity} dataTypeDecimalName="quantity" />
                              </div>
                              <div>
                                <span>Pending shares at selected price:</span>
                                {isNaN(execution.ExecutionPrice) || execution.ExecutionPrice == "" ? (
                                  "-"
                                ) : (
                                  <FormattedNumber
                                    value={
                                      pendingQuantity / (parseFloat(execution.ExecutionPrice) * parValue)
                                    }
                                    decimalScale={this.state.decimalAmount}
                                    dataTypeDecimalName="price"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </React.Fragment>
                  )}

                  {order.AssetClassForm !== "Repo" && (
                    <Row>
                      <Col lg={6}>
                        <Field
                          label={quantityIsCash ? "Quantity (shares)" : "Quantity"}
                          error={errors["ExecutionQuantity"]}
                        >
                          <NumberFormatInput
                            type="text"
                            customInput={Input}
                            value={parseFloat(execution["ExecutionQuantity"]) || ""}
                            invalid={!!errors["ExecutionQuantity"]}
                            disabled={loading}
                            onValueChange={(e) => {
                              this.onChange({ ExecutionQuantity: e.value });
                            }}
                            dataTypeDecimalName="quantity"
                            placeholder={"Quantity"}
                          />
                        </Field>
                      </Col>

                      <Col lg={6}>
                        <Field
                          label={
                            order.AssetClassForm == "Forex"
                              ? `Exchange rate (${baseCurrency}/${priceCurrency})`
                              : `Price (${order.OrderCurrencySymbol})`
                          }
                          error={errors["ExecutionPrice"]}
                        >
                          <NumberFormatInput
                            type="text"
                            customInput={Input}
                            value={parseFloat(execution["ExecutionPrice"]) || ""}
                            invalid={!!errors["ExecutionPrice"]}
                            onValueChange={(e) => {
                              this.onChange({ ExecutionPrice: e.value });
                            }}
                            decimalScale={this.state.decimalAmount}
                            dataTypeDecimalName="price"
                            disabled={loading}
                            placeholder={order.AssetClassForm == "Forex" ? `Exchange rate` : `Price`}
                          />
                        </Field>
                      </Col>
                    </Row>
                  )}

                  {order.AssetClassForm !== "Forex" &&
                    order.OrderCurrencySymbol !== order.OrderSettlementCurrencySymbol && (
                      <Row>
                        <Col lg={6}>
                          <Field label={`FX route`} error={errors["ExecutionFXRoute"]}>
                            <Combobox
                              value={execution["ExecutionFXRoute"]}
                              items={[
                                {
                                  id: "FXThroughCpty",
                                  description: "Through Cpty",
                                },
                                {
                                  id: "FXThroughOrder",
                                  description: "Through FX order",
                                },
                              ]}
                              disabled={loading}
                              onChange={(v) => this.onChange({ ExecutionFXRoute: v })}
                              emptyLabel={""}
                              invalid={!!errors["ExecutionFXRoute"]}
                              style={{ background: "#edf9ff", fontWeight: 500 }}
                            />
                          </Field>
                        </Col>
                        <Col lg={3}>
                          {execution["ExecutionFXRoute"] == "FXThroughCpty" && (
                            <Field>
                              <Switch
                                value={manualFX}
                                label={"Manual"}
                                onChange={(v) => this.setState({ manualFX: v })}
                              />
                            </Field>
                          )}
                        </Col>
                        <Col lg={3}>
                          {execution["ExecutionFXRoute"] == "FXThroughCpty" && (
                            <Field
                              label={`FX (${baseCurrency}/${priceCurrency})`}
                              error={errors["ExecutionFX"]}
                            >
                              <NumberFormatInput
                                type="text"
                                customInput={Input}
                                value={execution["ExecutionFX"] || ""}
                                invalid={!!errors["ExecutionFX"]}
                                onValueChange={(e) => {
                                  this.onChange({ ExecutionFX: e.value });
                                }}
                                disabled={loading || !manualFX}
                                placeholder={"FX"}
                                decimalScale={this.state.decimalAmount}
                                dataTypeDecimalName="currency"
                              />
                            </Field>
                          )}
                        </Col>
                      </Row>
                    )}

                  <Row>
                    <Col lg={6}>
                      {tradeRoutes != null && tradeRoutes.length < 1 ? (
                        <div className={style.item}>
                          <mark
                            className="fa fa-exclamation-triangle"
                            aria-hidden="true"
                            fontWeight="bold"
                            background-color="yellow"
                            color="black"
                          >
                            Unreachable trading route
                          </mark>
                        </div>
                      ) : (
                        <TradingRoutes
                          value={execution.TradingRouteId}
                          error={errors.TradingRouteId || execution.TradingRouteId === -1}
                          disabled={loading}
                          onChange={(id) => this.onChange({ TradingRouteId: id })}
                          tradeRoutes={tradeRoutes && tradeRoutes.length > 0 ? tradeRoutes : null}
                        />
                      )}
                    </Col>

                    {applyMarkupTrader && (
                      <Col lg={6}>
                        <Field
                          label={`Markup Price (${order.OrderCurrencySymbol})`}
                          error={errors["ExecutionMarkupPrice"]}
                        >
                          <NumberFormatInput
                            type="text"
                            customInput={Input}
                            value={parseFloat(execution["ExecutionMarkupPrice"]) || ""}
                            invalid={!!errors["ExecutionMarkupPrice"]}
                            onValueChange={(e) => {
                              this.onChange({ ExecutionMarkupPrice: e.value });
                            }}
                            decimalScale={this.state.decimalAmount}
                            dataTypeDecimalName="price"
                            disabled={loading}
                            placeholder={"Markup Price"}
                          />
                        </Field>
                      </Col>
                    )}

                    <Col lg={6}>
                      <CounterpartySuggest
                        value={execution.CounterPartyName}
                        disabled={loading}
                        onChange={(v) =>
                          this.onChange({
                            CounterPartyId: v.counterpartyId,
                            CounterPartyName: v.counterpartyName,
                          })
                        }
                        error={errors.CounterPartyId}
                        fetchItems={(v) => fetchCParties(v, entities.counterparties)}
                      />
                    </Col>
                  </Row>

                  {tradeRoutesLogs && (
                    <Row>
                      <Col lg={12}>
                        <TradingRoutesLogs logs={tradeRoutesLogs} />
                      </Col>
                    </Row>
                  )}
                  {execution.Fees && (
                    <Row>
                      <Col lg={12}>
                        <Field label="Fees">
                          <Fees fees={execution.Fees} />
                        </Field>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col lg={6}>
                      <Field label={"Trade Date"} error={errors["ExecutionDate"]}>
                        <Input
                          type="datetime-local"
                          placeholder={"Trade Date"}
                          step="1"
                          readOnly={loading}
                          value={execution["ExecutionDate"]}
                          invalid={!!errors["ExecutionDate"]}
                          onChange={(e) => this.onChangeTradeDate(e)}
                        />
                      </Field>
                    </Col>
                    <Col lg={6}>
                      <Field label={"Settlement Date (value date)"} error={errors["ExecutionValueDate"]}>
                        <Input
                          type="date"
                          placeholder={"Settlement Date"}
                          readOnly={loading}
                          value={execution["ExecutionValueDate"] || ""}
                          invalid={!!errors["ExecutionValueDate"]}
                          onChange={(e) => {
                            this.onChange({
                              ExecutionValueDate: e.target.value,
                            });
                            this.updateSettlementDate();
                          }}
                        />
                      </Field>
                    </Col>
                    {this.state.showTraderName && (
                      <Col lg={6}>
                        <Field label={"Trader Name"}>
                          <Input
                            type="select"
                            value={execution.ExecutionTrader}
                            onChange={(e) => this.handleSelectedTrader(e.target.value)}
                          >
                            <option value=""></option>
                            {this.state.authUsers &&
                              this.state.authUsers.map((option, index) => (
                                <option key={index} value={option.value}>
                                  {option.value}
                                </option>
                              ))}
                          </Input>
                        </Field>
                      </Col>
                    )}
                  </Row>
                  {order.AssetClassForm == "Repo" && execution.contractdata && (
                    <Row>
                      <Col>
                        <Row>
                          <Col>Contract Details</Col>
                        </Row>
                        <div className={style.contractDetailsWrapper}>
                          <Row>
                            <Col>
                              <Field label="Asset" error={errors["CollateralAsset"]}>
                                {order.OrderSide === "Sell" ? (
                                  <Input
                                    type="text"
                                    placeholder="Asset"
                                    disabled
                                    value={execution.contractdata.CollateralAssetTicker}
                                    onChange={(e) =>
                                      this.handleChangeContractData("CollateralAssetTicker", e.target.value)
                                    }
                                  />
                                ) : (
                                  <Symbol
                                    form={order.AssetClassForm}
                                    onChange={this.onChangeCollateral}
                                    placeholder={"Symbol"}
                                    disabled={loading}
                                    invalid={!!errors["CollateralAsset"]}
                                    value={execution.contractdata.CollateralAssetTicker}
                                    description={order.CurrentAccount.AssetDescription}
                                    provider={order.CurrentAccount.AssetSecurityProvider}
                                    assetid={order.CurrentAccount.AssetId}
                                    attrId={"AssetId"}
                                    attrTicker={"AssetTicker"}
                                    attrDescription={"AssetDescription"}
                                    attrProvider={"AssetSecurityProvider"}
                                    searchSymbol={fetchSearchSymbol}
                                    searchRepoSymbol={fetchSearchRepoSymbol}
                                    getYahooOptions={fetchYahooOptions}
                                    hideInfo
                                    assetInfo={() =>
                                      customFetchAssetInfo(
                                        dispatch,
                                        { assetInfo: fetchOrderAssetInfo },
                                        order
                                      )
                                    }
                                  />
                                )}
                              </Field>
                            </Col>
                            <Col>
                              <Row>
                                <Col>
                                  <Field label="Quantity" error={errors["CollateralQuantity"]}>
                                    <NumberFormatInput
                                      type="text"
                                      customInput={Input}
                                      value={parseFloat(execution.contractdata.CollateralQuantity)}
                                      onValueChange={(e) => {
                                        this.handleChangeContractData("CollateralQuantity", e.value);
                                      }}
                                      dataTypeDecimalName="quantity"
                                      disabled={loading}
                                      placeholder="Quantity"
                                    />
                                  </Field>
                                </Col>
                                @
                                <Col>
                                  <Field label="Price">
                                    <NumberFormatInput
                                      type="text"
                                      customInput={Input}
                                      value={parseFloat(execution.contractdata.price)}
                                      onValueChange={(e) => {
                                        this.handleChangeContractData("price", e.value);
                                      }}
                                      decimalScale={this.state.decimalAmount}
                                      dataTypeDecimalName="price"
                                      disabled={loading}
                                      placeholder="Price"
                                    />
                                  </Field>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <Row>
                                <Col>
                                  <Field label="Appraisal" error={errors["CollateralAppraisal"]}>
                                    <NumberFormatInput
                                      type="text"
                                      customInput={Input}
                                      value={parseFloat(execution.contractdata.appraisal)}
                                      onValueChange={this.handleChangeAppraisal}
                                      dataTypeDecimalName="percentage"
                                      allowNegative={false}
                                      disabled={loading}
                                      placeholder="Appraisal"
                                      suffix="%"
                                    />
                                  </Field>
                                </Col>
                                <Col>
                                  <Field label="Haircut" error={errors["CollateralHaircut"]}>
                                    <NumberFormatInput
                                      type="text"
                                      customInput={Input}
                                      value={parseFloat(execution.contractdata.margin)}
                                      onValueChange={this.handleChangeHaircut}
                                      dataTypeDecimalName="percentage"
                                      allowNegative={false}
                                      disabled={loading}
                                      placeholder="Haircut"
                                      suffix="%"
                                    />
                                  </Field>
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>
                                <Col>
                                  <Field label="Market Value">
                                    <NumberFormatInput
                                      type="text"
                                      customInput={Input}
                                      value={execution.contractdata.marketValue}
                                      onValueChange={(e) => {
                                        this.handleChangeContractData("marketValue", e.value);
                                      }}
                                      dataTypeDecimalName="price"
                                      disabled
                                      placeholder="Market Value"
                                    />
                                  </Field>
                                </Col>
                                <Col>
                                  <Field label="Currency">
                                    <Input
                                      type="text"
                                      value={execution.contractdata.currency}
                                      disabled
                                      placeholder="Currency"
                                    />
                                  </Field>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <Field label="Maturity" error={errors["CollateralMaturity"]}>
                                <Input
                                  type="date"
                                  placeholder={"Maturity"}
                                  step="1"
                                  readOnly={loading}
                                  value={execution.contractdata.maturity}
                                  onChange={(e) => this.handleChangeContractData("maturity", e.target.value)}
                                />
                              </Field>
                            </Col>
                            <Col>
                              <Row>
                                <Col>
                                  <Field label="Rate" error={errors["CollateralRate"]}>
                                    <NumberFormatInput
                                      type="text"
                                      customInput={Input}
                                      value={parseFloat(execution.contractdata.rate)}
                                      onValueChange={(e) => {
                                        this.handleChangeContractData("rate", e.value);
                                      }}
                                      dataTypeDecimalName="percentage"
                                      disabled={loading}
                                      placeholder="Rate"
                                      suffix="%"
                                    />
                                  </Field>
                                  <CustomInput
                                    type="checkbox"
                                    id="check-paymentToBorrower"
                                    name="check-paymentToBorrower"
                                    label="Payments go to repo borrower"
                                    // className="pl-1 mt-1"
                                    checked={execution.contractdata.paymenttoborrower}
                                    onChange={() =>
                                      this.handleChangeContractData(
                                        "paymenttoborrower",
                                        !execution.contractdata.paymenttoborrower
                                      )
                                    }
                                  />
                                </Col>
                                <Col>
                                  <div className={style.leg}>
                                    <span className={style.opening}>Opening leg</span>{" "}
                                    {execution.contractdata.currency}{" "}
                                    {this.state.calculatingLegs ? (
                                      <CircularProgress sm />
                                    ) : (
                                      <FormattedNumber
                                        value={execution.contractdata.opening}
                                        dataTypeDecimalName="currency"
                                      />
                                    )}
                                  </div>
                                  <div className={style.leg}>
                                    <span className={style.closing}>Closing leg</span>{" "}
                                    {execution.contractdata.currency}{" "}
                                    {this.state.calculatingLegs ? (
                                      <CircularProgress sm />
                                    ) : (
                                      <NumberFormatInput
                                        type="text"
                                        customInput={Input}
                                        value={execution.contractdata.closing}
                                        onValueChange={(e) => {
                                          this.handleChangeClosingLeg("closing", e.value);
                                        }}
                                        dataTypeDecimalName="currency"
                                        placeholder="Closing Leg"
                                      />
                                    )}
                                  </div>
                                  <CouponPayments payments={execution.contractdata.couponPayments} />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col lg={12} style={{ textAlign: "center" }}>
                      <LaddaButton
                        className="btn btn-ladda btn-primary"
                        loading={loading}
                        disabled={loading}
                        onClick={() => this.confirm()}
                        style={{ marginTop: "8px" }}
                        data-style={SLIDE_LEFT}
                      >
                        {"Confirm execution"}
                      </LaddaButton>
                    </Col>
                  </Row>
                </Fragment>
              )}

              <br />

              <ExecutionsTable
                sendingExecsIdsLoading={this.state.loadingSendExecsIds}
                onDelete={this.delete}
                onSendExecutionToBO={() => null}
                executions={executions}
                showDelete={isManualAndActive}
                decimalAmount={this.state.decimalAmount}
                minimumFractionDigits={quantityIsCash ? maxDecimals : 2}
              />
            </Container>
          </ModalBody>
          <ModalFooter>
            {this.state.calculatingTotal ? (
              <CircularProgress sm style={{ margin: 0, width: "16px", height: "16px" }} />
            ) : (
              this.state.total && (
                <p className="text" style={{ fontWeight: "bold" }}>
                  Total <FormattedNumber value={this.state.total} />
                </p>
              )
            )}

            <Button color="light" onClick={this.onToggle}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const Fees = ({ fees }) => {
  return (
    <div className={style.feesContainer}>
      <Table className={style.feesTable} responsive>
        <thead>
          <tr>
            <th>Description</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {fees.map((feeItem, idx) => (
            <tr key={idx}>
              <td>{feeItem.Description}</td>
              <td>
                <FormattedNumber value={feeItem.FeeAmount} dataTypeDecimalName="currency" />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default Execution;
